import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import useUserHidden from '../hooks/useUserHidden';
const SuspensionBannersContext = /*#__PURE__*/createContext({});
const INITIAL_STATUS_STATE = {};

const SuspensionBannersContextProvider = ({
  children
}) => {
  const [status, setStatus] = useState(INITIAL_STATUS_STATE);
  const [bannerHiddenByUserFor, setBannerHiddenByUserFor] = useUserHidden();
  const value = {
    bannerHiddenByUserFor,
    setBannerHiddenByUserFor,
    statusFor: scope => status[scope],
    setStatusFor: scope => val => setStatus(prev => Object.assign({}, prev, {
      [scope]: val
    }))
  };
  return /*#__PURE__*/_jsx(SuspensionBannersContext.Provider, {
    value: value,
    children: children
  });
};

export default SuspensionBannersContext;
export { SuspensionBannersContextProvider };